module.exports = __webpack_public_path__ + "static/media/no-images.1893e91b.webp";